import { Box, Stack, Typography } from "@mui/material";
import { FC, useEffect, useMemo } from "react";
import { containerSX } from "./styles/container";
import { useSettings } from "@/data/Settings";
import { ItnlIntegrationScript } from "@/data/types/ItnlIntegrationScript";
import { loadExternalScripts, removeScripts } from "@/utils/loadExternalScripts";
import { id } from "date-fns/locale";

const PDPBazaarVoiceSummary:FC<{partNumber:string, catentryId:string}> = ({partNumber, catentryId}) => {
    const { settings } = useSettings();
    const { bvClientName, bvSiteId, bvEnvironment, bvLocale } = useMemo(() => settings.userData, [settings]);
    useEffect(() => {
        if (id && bvClientName) {
            const scripts: ItnlIntegrationScript[] = [
                {
                    id: "bazaar_voice_script",
                    retainScript: true,
                    skipIfExists: true,
                    url: `https://apps.bazaarvoice.com/deployments/${bvClientName}/${bvSiteId}/${bvEnvironment}/${bvLocale}/bv.js`
                }
            ]
            loadExternalScripts(scripts);
            return (() => removeScripts(scripts))
        }
    }, [id, bvClientName]);

    return(
        <Stack direction="row" sx={containerSX}>
            <Box data-bv-show="rating_summary" data-bv-product-id={`${partNumber}`} className='rating_summary'></Box>
            <Typography component="span" id={`product_SKU_${catentryId}`}>{partNumber}</Typography>
        </Stack>
    );
}

export default PDPBazaarVoiceSummary;